import clsx from 'clsx';

const renderTextWithMarks = (item: any, locationData?: string) => {
  if (!item.marks || item.marks.length === 0) {
    return item.value;
  }

  let result = <>{item.value}</>;

  // Apply each mark to the text
  item.marks.forEach((mark: any) => {
    switch (mark.type) {
      case 'bold':
        result = <strong className={clsx('font-bold', locationData === 'blog' ? 'text-GREEN-500' : '')}>{result}</strong>;
        break;
      case 'italic':
        result = <em className="italic">{result}</em>;
        break;
      case 'underline':
        result = <span className="underline">{result}</span>;
        break;
      case 'superscript':
        result = <sup className="text-xs">{result}</sup>;
        break;
      case 'subscript':
        result = <sub className="text-xs">{result}</sub>;
        break;
      case 'strikethrough':
        result = <span className="line-through">{result}</span>;
        break;
      default:
        break;
    }
  });

  return result;
};

export { renderTextWithMarks };
